import {useEffect, useState} from "react";
import { useNavigate } from "react-router";
import Api from "../../services/Api.ts";
import { CategoryInterface} from "../interfaces/category_interfaces.ts";


export default function Categories() {
  const api = Api.getInstance();
  const navigate = useNavigate();
  const [categories, setCategories] = useState<Array<CategoryInterface>>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {

    api.get('customer/categories').then((response) => {
      setCategories(response.json.categories);
      setLoaded(true);
    })
  }

  if (!loaded) {
    return <div>Loading data...</div>
  }

  return (
    <div className="main">
      <div className="mt-4 text-3xl font-medium">Categories</div>
      <p className="mt-2 text-neutral-400">
        This dashboard gives you an overview of your organization’s categories.
      </p>

      {
        categories.map((category) => (
          <div className="mt-4 z-box cursor-pointer" key={"cat_" + category.id}
               onClick={() => navigate('/categories/' + category.id)}>
            <p className="text-xl">{category.name}</p>
          </div>
        ))
      }
    </div>
  );
}